module.exports = __webpack_public_path__ + "static/media/ic-link.8b7ccbd0.svg";